import {makeStyles} from 'tss-react/mui'

export const useStyles = makeStyles()((theme) => ({
  container: {
    marginTop: theme.spacing(2)
  },
  title: {
    fontSize: '18px',
    fontWeight: 600
  },
  description: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '24px',
    color: '#29333D',
    marginBottom: '20px'
  },
  gridContainer: {
    marginBottom: '20px'
  },
  gridItem: {
    position: 'relative',
    width: '100%'
  },
  select: {
    fontSize: '14px',
    width: '100%',
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '4px',
      border: '1.5px solid rgba(0, 39, 77, 0.15)'
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: '1.5px solid rgba(0, 39, 77, 0.15) !important'
    }
  }
}))
